module.exports = __webpack_public_path__ + "static/media/robson.2e967022.jpg";